import { dynamicElementsAuthorKey } from '@epicuro-next/constants/dynamic-elements';
import { OPENED_LIST_DATA_PROVIDER_KEY } from '@epicuro-next/data-providers/providers-registry';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export const authorItem: IDynamicItem = {
  contentTypeId: dynamicElementsAuthorKey,
  inputs: {
    user: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'creation.user',
    },
    date: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'update.dateUtc',
    },
  },
};
